<template>
  <div style="height:100%">
    <portal to="app-header">
      <v-btn
        icon
        class="mb-1"
        @click="goBack"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span>New Production Order</span>
    </portal>
    <SalesForm></SalesForm>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SalesForm from '../components/SalesForm.vue';

export default {
  name: 'CreateNew',
  components: {
    SalesForm,
  },
  computed: {
    ...mapState('fileManager', ['loading', 'noResult']),
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'sales' });
    },
  },
};
</script>

<style lang="scss" scoped>
.border-round {
  border-radius: 10px;
}
#home-container {
  height: calc(100vh - 220px);
  overflow: auto;
}
</style>
